import React from "react";

const UpdatesAndFaqPageIframe: React.FC = () => {
  return (
    <iframe
      src="https://reminiscent-attack-2ed.notion.site/ebd/2467872a950b8077bfbef0f6fe0b2d19"
      className="w-full h-screen"
      frameBorder="0"
      allowFullScreen
    />
  );
};

export default UpdatesAndFaqPageIframe;